import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-purchase-dashboard',
  templateUrl: './purchase-dashboard.component.html',
  styleUrls: ['./purchase-dashboard.component.scss']
})
export class PurchaseDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
